import { Component, OnInit, ViewChild } from '@angular/core';
import { Form, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { UserDto, UserNoIdDto } from 'src/app/shared/models/user/user-dto';
import { UserService } from 'src/app/shared/services/user/user.service';
import { UserFormComponent } from '../components/user-form/user-form.component';

@Component({
    selector: 'app-update-user',
    templateUrl: './update-user.component.html',
    standalone: false
})
export class UpdateUserComponent implements OnInit {
  loading = false;
  userId: number = null;
  user: UserDto = null;

  @ViewChild(UserFormComponent) userForm: UserFormComponent;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly alertService: AlertService
  ) {}

  get form(): FormGroup {
    return this.userForm?.form;
  }

  get values(): any {
    return this.form?.value;
  }

  setLoading(state: boolean) {
    this.loading = state;
  }

  submitForm() {
    if (this.form.invalid) {
      return this.alertService.showAlert({ type: 'critical', content: 'Preencha o formulário corretamente.' } as Alert);
    }

    if (this.values?.password != this.values?.passwordConfirm) {
      return this.alertService.showAlert({ type: 'critical', content: 'As senhas não são iguais.' } as Alert);
    }

    const userData: UserNoIdDto = {
      userId: this.values?.email,
      userProfileId: this.values?.userProfile?.id,
      companyId: this.values?.company?.id,
      name: this.values?.name,
      userName: this.values?.email,
      password: this.values?.password,
      enabled: this.values?.enabled
    };

    this.loading = true;

    this.userService
      .update(this.userId, userData)
      .subscribe({
        next: () => {
          this.alertService.showAlert({ type: 'success', content: 'Usuário atualizado com sucesso.' } as Alert);
        },
        error: () => {
          this.alertService.showAlert({ type: 'critical', content: 'Ocorreu um erro ao cadastrar o usuário.' } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }

  ngOnInit() {
    this.loading = true;
    this.userId = this.route.snapshot.params['id'];
    this.userService
      .findById(this.userId)
      .subscribe({
        next: (result) => (this.user = result),
        error: () =>
          this.alertService.showAlert({ type: 'critical', content: 'Ocorreu um erro ao recuperar as informações do usuário.' } as Alert)
      })
      .add(() => (this.loading = false));
  }
}
